import AxiosClient from "./axiosClient";

const VnPayApi = {
    createPayment: (params) => {
        const url = "vn-pay/create-payment"
        return AxiosClient.post(url, params)
    }
}

export default VnPayApi